import { T as o, d as c, P as t, O as a, L as i, c as p, V as w, C as e } from "../../brands-CoixlYYY.js";
const l = {
  [e]: "https://www.capitalone.co.uk/compliance/cookie-policy",
  [w]: "https://www.capitalone.co.uk/very/cookie-policy",
  [p]: "https://www.capitalone.co.uk/asos/cookie-policy",
  [i]: "https://www.capitalone.co.uk/littlewoods/cookie-policy",
  [a]: "https://www.capitalone.co.uk/ocean/cookie-policy",
  [t]: "https://www.capitalone.co.uk/postoffice/cookie-policy",
  [c]: "https://www.capitalone.co.uk/luma/cookie-policy",
  [o]: "https://www.capitalone.co.uk/thinkmoney/cookie-policy"
};
export {
  l as default
};
